import { Breadcrumbs, Typography } from '@mui/material';
import Header from 'components/header';
import { Product } from 'components/product';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link as LinkRout } from 'react-router-dom';

const Catalog = () => {
    const products = useSelector((state) => state.state.products);
    return (
        <div>
            <Header />
            <div className="wrapper owerflow">
                <section className="section">
                    <div className="container">
                        <Breadcrumbs className="breadcrumbs" aria-label="breadcrumb">
                            <LinkRout underline="hover" color="inherit" to="/">
                                Главная
                            </LinkRout>
                            <Typography color="text.primary">Каталог</Typography>
                        </Breadcrumbs>
                        <h1 className="page_title">
                            КАТАЛОГ
                            <br />
                            MILLIDGE
                        </h1>
                        <div className="products">
                            {products.map((product) => (
                                <Product key={product.id} {...product} />
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Catalog;
